import { render } from "./PageControl.vue?vue&type=template&id=35c8f2f6&scoped=true"
import script from "./PageControl.vue?vue&type=script&lang=js"
export * from "./PageControl.vue?vue&type=script&lang=js"

import "./PageControl.vue?vue&type=style&index=0&id=35c8f2f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c8f2f6"]])

export default __exports__